import {Injectable, inject} from '@angular/core';
import {Observable, of} from 'rxjs';
import { HttpClient, HttpParams } from "@angular/common/http";
import {AppSetting} from '../app.setting';
import {SimpleXploreItemDTO, XploreItemDTO} from '../shared/object/xplorer-be-parsed-classes';
import {environment} from "../../environments/environment";
import {TerritoryService} from "./geolocation/territory.service";


@Injectable({
  providedIn: 'root',
})
export class XploreItemService {
  private readonly sessionSeed: number;
  private readonly http = inject(HttpClient);
  private readonly appSetting = inject(AppSetting);
  private readonly territoryService = inject(TerritoryService);

  constructor() {
    this.sessionSeed = this.appSetting.getSessionSeed();
  }

  getXploreItemsFilteredByTagAndName(name: string, tags: string[], pageNumber: number): Observable<XploreItemDTO[]> {
    let params = this.buildParams(tags, name, pageNumber);

    return this.http.get<XploreItemDTO[]>(`${environment.API_URL}/xplore/filter`, {params: params});
  }

  getSimpleXploreItemsFilteredByTagAndName(name: string, tags: string[], pageNumber: number): Observable<SimpleXploreItemDTO[]> {
    let params = this.buildParams(tags, name, pageNumber);

    return this.http.get<SimpleXploreItemDTO[]>(`${environment.API_URL}/xplore/simple/filter`, {params: params});
  }

  getPagedXploreItems(pageNumber: number): Observable<XploreItemDTO[]> {
    let params = this.buildStandardParams();
    return this.http.get<XploreItemDTO[]>(`${environment.API_URL}/xplore/paged/${pageNumber}/${this.sessionSeed}`, {params: params});
  }

  getPagedSimpleXploreItems(pageNumber: number): Observable<SimpleXploreItemDTO[]> {
    let params = this.buildStandardParams();
    return this.http.get<SimpleXploreItemDTO[]>(`${environment.API_URL}/xplore/simple/paged/${pageNumber}/${this.sessionSeed}`, {params: params});
  }

  getXploreItems(): Observable<XploreItemDTO[]> {
    let params = this.buildStandardParams();
    return this.http.get<XploreItemDTO[]>(`${environment.API_URL}/xplore`, {params: params});
  }

  getXploreItemById(id: string | number): Observable<XploreItemDTO> {
    return this.http.get<XploreItemDTO>(`${environment.API_URL}/xplore/id/${id}`);
  }

  getSimpleXploreItemById(id: string | number): Observable<SimpleXploreItemDTO> {
    return this.http.get<SimpleXploreItemDTO>(`${environment.API_URL}/xplore/simple/${id}`);
  }

  getNearbySimpleXploreItems(xploreId: number): Observable<SimpleXploreItemDTO[]> {
    let params = this.buildStandardParams();
    return this.http.get<SimpleXploreItemDTO[]>(`${environment.API_URL}/xplore/nearby/${xploreId}`, {params: params});
  }

  getNearbyUserSimpleXploreItems(userPosition: GeolocationPosition): Observable<SimpleXploreItemDTO[]> {
    if (!userPosition?.coords) {
      return this.getPagedSimpleXploreItems(0);
    }
    let params = this.buildStandardParams();
    return this.http.get<SimpleXploreItemDTO[]>(`${environment.API_URL}/xplore/nearby/${userPosition.coords.latitude}/${userPosition.coords.longitude}`, {params: params});
  }

  private buildStandardParams(noDraft: boolean = true): HttpParams {
    return new HttpParams()
      .set('territoryCode', this.territoryService.getTerritoryCodeFromUrl())
      .set('noDraft', noDraft);
  }

  private buildParams(tags: string[], name: string, pageNumber: number) {
    let params = this.buildStandardParams();

    if (tags.length > 0) {
      params = params.set('tags', tags.join(','));
    }

    if (name) {
      params = params.set('name', name);
    }

    return params.set('pageNumber', pageNumber.toString());
  }
}
